import { Pipe, PipeTransform } from "@angular/core";
import { Util } from "../util/util";

@Pipe({
    name: 'diaSemanaPipe',
    pure: true
})

export class DiaSemanaPipe implements PipeTransform {

    transform(value: number, args?: any): any {

        let valorFormatado: string = '';

        if (value == 1) {
            valorFormatado = Util.listaDiasDaSemana[0].descricao;
        } else if (value == 2) {
            valorFormatado = Util.listaDiasDaSemana[1].descricao;
        } else if (value == 3) {
            valorFormatado = Util.listaDiasDaSemana[2].descricao;
        } else if (value == 4) {
            valorFormatado = Util.listaDiasDaSemana[3].descricao;
        } else if (value == 5) {
            valorFormatado = Util.listaDiasDaSemana[4].descricao;
        } else if (value == 6) {
            valorFormatado = Util.listaDiasDaSemana[5].descricao;
        } else if (value == 7) {
            valorFormatado = Util.listaDiasDaSemana[6].descricao;
        }

        return valorFormatado;
    }

}
